import * as React from 'react';

import { SVGComponentProps } from './svg.types';

const SketchNoteLogoTwoSVG = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherSvgProps
}: SVGComponentProps) => (
  <span className={`inline-block ${wrapperClass || ''}`}>
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby="sketchnote-logo-two"
      {...otherSvgProps}
    >
      <title id="sketchnote-logo-two">View sketchnote home</title>
      <path
        d="M0 8.08035C0 3.6177 3.61769 0 8.08034 0H39.9197C44.3823 0 48 3.61769 48 8.08034V39.9197C48 44.3823 44.3823 48 39.9197 48H8.08035C3.6177 48 0 44.3823 0 39.9197V8.08035Z"
        fill="#254DDA"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.4424 25.2375C13.8595 16.8324 20.6218 10.0824 29.077 9.60217C29.5842 9.57337 29.9742 10.0231 29.8989 10.5215L28.1724 21.9391H33.365C33.8239 21.9391 34.1982 22.3086 34.1756 22.7633C33.7584 31.1684 26.9962 37.9184 18.541 38.3986C18.0338 38.4274 17.6437 37.9777 17.7191 37.4793L19.4456 26.0617H14.253C13.794 26.0617 13.4198 25.6922 13.4424 25.2375Z"
        fill={fill}
      />
    </svg>
  </span>
);

export default SketchNoteLogoTwoSVG;
